<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-select
            codeGroupCd="RELATED_LAWS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="relatedLawsCd"
            label="관련법규"
            v-model="searchParam.relatedLawsCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            name="search"
            placeholder="인허가 종류명"
            label="인허가 종류명"
            v-model="searchParam.limLicenseKindName"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="인허가 현황 목록"
      :columns="grid.columns"
      :data="grid.data"
      gridHeightAuto
      :selection="popupParam.type"
      rowKey="limLicenseKindId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="선택" icon="check" @btnClicked="select" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "license-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          processCd: "",
          plantCd: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        limLicenseKindName: "",
        relatedLawsCd: null,
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "revisionNum",
            field: "revisionNum",
            label: "Rev.",
            align: "center",
            style: "width:50px",
            sortable: true,
          },
          {
            name: "relatedLawsName",
            field: "relatedLawsName",
            label: "관련법규",
            align: "center",
            sortable: true,
          },
          {
            name: "limLicenseKindName",
            field: "limLicenseKindName",
            label: "인허가종류",
            align: "left",
            type: "link",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: "",
      kindlistUrl: "",
    };
  },
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.listUrl = selectConfig.sop.lim.lincense.card.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내", // 안내
          message: "인허가를를 선택하세요.", // 인허가를를 선택하세요
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
  },
};
</script>
